import React from 'react'
import "./Lista.css"
import ProductList from './ProductList'
import { Link } from 'react-router-dom';

function Lista() {
    
    return (
        <div className= "Lista">
            <div className="Lista_Name">
                <div className= "Lista_Name_Title">Productos
                <div className= "Lista_Name_Page"><Link to="/"><span>Inicio</span></Link> > <span >Catalogo</span></div>

                </div>
                                </div>
                <div className="Lista_Content">
                <div className="Lista_Catalogo"> 
            <ProductList  id= "1" title='Cubrebocas KN95 Certificado Precio Mayoreo Mascarilla 10pz' price= {29.99} image="http://pngimg.com/uploads/medical_mask/medical_mask_PNG53.png"
             rating= {5}/> 
             <ProductList id= "8" title='Microflex SG375L SafeGrip Powder Free Latex Glove Size Large (Box of 50)' price= {39.99} image="http://pngimg.com/uploads/medical_gloves/medical_gloves_PNG130.png"
             rating= {2}/>   
            <ProductList id= "2" title='Cycling Fishing Golf Blade Sport Polarized Sunglasses' price= {10.00} image="http://pngimg.com/uploads/thermometer/thermometer_PNG63.png"
             rating= {5}/>     
            <ProductList id= "3" title='Tobacco: A Cultural History of How an Exotic Plant Seduced Civilization' price= {15.99} image="http://pngimg.com/uploads/tobacco/tobacco_PNG36.png"
             rating= {3}/>  
            <ProductList id= "4" title='Cycling Fishing Golf Blade Sport Polarized Sunglasses' price= {10.00} image="http://pngimg.com/uploads/multi_tool/multi_tool_PNG93.png"
             rating= {5}/>     
            <ProductList id= "5" title='Tobacco: A Cultural History of How an Exotic Plant Seduced Civilization' price= {15.99} image="http://pngimg.com/uploads/tobacco/tobacco_PNG36.png"
             rating= {3}/>   
            <ProductList  id= "6" title='Westmon Works Seashell Driftwood Decoración móvil para el hogar de 6 pulgadas de largo' price= {89.99} image="http://pngimg.com/uploads/seashell/seashell_PNG83.png"
             rating= {4}/>  
             <ProductList id= "7" title='Cycling Fishing Golf Blade Sport Polarized Sunglasses' price= {10.00} image="http://pngimg.com/uploads/hammer/hammer_PNG1131.png"
             rating= {5}/> 

           
            </div>
            <div className="Lista_Sidebar">
                <div className="Lista_Title">
                    <span>Categorías</span>
                </div> 
                <ul>
                    <li>Todos <span className="dots" /></li>
                    <li>Insumos Médicos <span className="dots" /></li>
                    <li>Ropa Quirúrjica <span className="dots"> </span></li>
                    <li>Cubrebocas <span className="dots" /></li>
                    <li>Equipo Médico <span className="dots"/></li>
                    <li>Pruebas <span className="dots" /></li>
                </ul>

               
            </div>
            </div>
            
        </div>
    )
}

export default Lista
